import React, { FC, MouseEvent, useContext, useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { isProfileBetbookMaintenance } from '../../profiles';
import { isMobileChannel } from '../../common/util';
import { SvgIcon } from '../../icons/SvgIcon';
import i18n from '../../common/i18n';
import { openDialog } from '../dialogs/dialogs';
import { nuiCtx } from '../../common/initialization';
import { getModalPost$, loadBetbookModalPost, postsModalClean } from './h&s';
import { POST_ANALYSIS } from '../betbook/constants';
import BetLocationContext from '../../common/BetLocationContext';
import clsx from 'clsx';

const AnalysisButton: FC<{ postId: number; className?: string }> = ({ postId, className }) => {
    const { betLocationSection } = useContext(BetLocationContext);
    return postId && !isProfileBetbookMaintenance() ? (
        isMobileChannel() ? (
            <AnalysisIcon />
        ) : (
            <button className={clsx('p-0 fs-0', className)} onClick={openAnalysis(postId, betLocationSection)}>
                <AnalysisIcon />
            </button>
        )
    ) : null;
};

export const AnalysisIcon: FC<{ className?: string }> = ({ className }) => {
    return (
        <SvgIcon
            imgId="live-analyse"
            title={i18n('nui.turbo.live.icon.analysis')}
            sizeX="14"
            sizeY="14"
            className={clsx('match-icon c-black-25 fs-0 flex-shrink-0 mx-5 my-2', className)}
        />
    );
};

const openAnalysis = (postId: number, betLocationSection?: object) => (e: MouseEvent<HTMLElement>): void => {
    e?.preventDefault();
    e?.stopPropagation();
    const { NuiDialog } = nuiCtx.components;
    const dialogName = 'nui/analysis/dialog';
    openDialog({
        name: dialogName,
        component: () => (
            <NuiDialog
                name={dialogName}
                className={isMobileChannel() ? 'dialog-post-table' : 'modal-analysis'}
                bounceLeft
                modalOffer
                noPad
            >
                <BetLocationContext.Provider value={{ betLocationSection }}>
                    <BetbookAnalysis postId={postId} detail modal header />
                </BetLocationContext.Provider>
            </NuiDialog>
        )
    });
};

const BetbookAnalysis: FC<{
    postId: number;
    detail?: boolean;
    header?: boolean;
    modal?: boolean;
}> = ({ postId, detail, header, modal }) => {
    const { BetbookPostItem } = nuiCtx.components;
    const { subscribe } = useReframe();
    const post = modal ? subscribe(getModalPost$(postId)) : null;
    const noModalData = modal && post === undefined;
    useEffect(() => {
        if (noModalData) {
            loadBetbookModalPost(postId);
        }
        return () => {
            if (post) {
                dispatch(postsModalClean);
            }
        };
    }, [postId, noModalData, post]);
    return !noModalData ? <>{BetbookPostItem(POST_ANALYSIS, post, detail, header)}</> : null;
};

export default AnalysisButton;
